import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ServiceTypeEntity from '../entities/ServiceType.Entity';

export function getAllServiceTypesByVendor(serviceId: number, vendorId:number, abortSignal: AbortSignal): Promise<Array<ServiceTypeEntity>> {
    return apiGet<Array<ServiceTypeEntity>>('/services/' + serviceId + '/service-types-by-vendor/'+ vendorId, abortSignal);
}